import React from 'react';
import { Menu, X, Instagram } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_cda4d3ce-07c4-4663-8a1d-3cb128cb90cd/artifacts/ybet6u5o_cosme-alberdi-logo.jpg';

const Header = ({ mobileMenuOpen, toggleMobileMenu, closeMobileMenu }) => {
  const navLinks = [
    { href: '#inicio', label: 'Inicio' },
    { href: '#nosotros', label: 'Nosotros' },
    { href: '#carta', label: 'Carta' },
    { href: '#opiniones', label: 'Opiniones' },
    { href: '#ubicacion', label: 'Ubicación' },
  ];

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-30 bg-[#0d0d0d]/95 backdrop-blur-sm border-b border-[#252525]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 md:h-20">
            {/* Logo */}
            <a href="#inicio" className="flex items-center">
              <img 
                src={LOGO_URL} 
                alt="Cosme Alberdi" 
                className="h-12 md:h-14 w-auto rounded-full"
              />
            </a>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-8">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="font-heading text-sm uppercase tracking-wider text-gray-300 hover:text-[#7cb342] transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </nav>

            {/* Desktop CTA */}
            <div className="hidden md:flex items-center gap-4">
              <a
                href="https://www.instagram.com/cosme.alberdi"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-[#7cb342] transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={22} />
              </a>
              <a
                href="https://wa.me/5493416802275"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary px-5 py-2 rounded-lg font-heading text-sm uppercase tracking-wider font-semibold"
              >
                Contactar
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={toggleMobileMenu}
              className="md:hidden p-2 text-gray-300 hover:text-[#7cb342] transition-colors"
              aria-label={mobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
            >
              {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <div 
        className={`menu-overlay ${mobileMenuOpen ? 'active' : ''}`}
        onClick={closeMobileMenu}
      />

      {/* Mobile Menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'active' : ''}`}>
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between p-4 border-b border-[#252525]">
            <img 
              src={LOGO_URL} 
              alt="Cosme Alberdi" 
              className="h-10 w-auto rounded-full"
            />
            <button
              onClick={closeMobileMenu}
              className="p-2 text-gray-300 hover:text-[#7cb342] transition-colors"
              aria-label="Cerrar menú"
            >
              <X size={24} />
            </button>
          </div>
          
          <nav className="flex flex-col p-4 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={closeMobileMenu}
                className="font-heading text-lg uppercase tracking-wider text-gray-300 hover:text-[#7cb342] py-3 border-b border-[#252525] transition-colors"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="mt-auto p-4 border-t border-[#252525]">
            <a
              href="https://wa.me/5493416802275"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMobileMenu}
              className="btn-primary w-full py-3 rounded-lg font-heading text-center uppercase tracking-wider font-semibold block"
            >
              Contactar por WhatsApp
            </a>
            <a
              href="https://www.instagram.com/cosme.alberdi"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMobileMenu}
              className="flex items-center justify-center gap-2 mt-3 text-gray-300 hover:text-[#7cb342] transition-colors"
            >
              <Instagram size={20} />
              <span className="font-body">@cosme.alberdi</span>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
